// extracted by mini-css-extract-plugin
export var box = "_5y-1";
export var checkboxRow = "_5y-8";
export var checked = "_5y-2";
export var descriptionSpacer = "_5y-a";
export var disabled = "_5y-3";
export var icon = "_5y-6";
export var input = "_5y-0";
export var labelSpacer = "_5y-9";
export var medium = "_5y-5";
export var small = "_5y-4";
export var text = "_5y-7";